/**
 * Phân quyền Chat — phân hệ riêng (không thuộc WEB_BH_*).
 * Mirror auth `banHangWebMenu` menu Chat.
 */
export const CHAT_PERMISSION_CODES = {
  /** Inbox danh sách nhóm / DM */
  WEB_CHAT_LIST: 'WEB_CHAT_LIST',
  /** Nhắn tin, tạo nhóm/DM, thành viên, gửi báo cáo */
  WEB_CHAT_CHAT: 'WEB_CHAT_CHAT',
} as const

export type ChatPermissionCode =
  (typeof CHAT_PERMISSION_CODES)[keyof typeof CHAT_PERMISSION_CODES]

export const CHAT_READ_PERMISSIONS = [
  CHAT_PERMISSION_CODES.WEB_CHAT_LIST,
  CHAT_PERMISSION_CODES.WEB_CHAT_CHAT,
] as const

export const CHAT_MUTATE_PERMISSIONS = [
  CHAT_PERMISSION_CODES.WEB_CHAT_CHAT,
] as const
